import { ArrowUpRight } from "react-bootstrap-icons";
export const Footer = () => (
  <footer className="site-footer page-shell">
    <div>
      <a href="#home" className="wordmark">
        aaron<span>.</span>
      </a>
      <p>Thoughtfully built. Always evolving.</p>
    </div>
    <div className="footer-links">
      <a href="https://github.com/aaronzz" target="_blank" rel="noreferrer">
        GitHub <ArrowUpRight aria-hidden="true" />
      </a>
      <a href="#home">
        Back to top <ArrowUpRight aria-hidden="true" />
      </a>
      <span>© {new Date().getFullYear()} Aaron Zhang</span>
    </div>
  </footer>
);
